<div class="grid">
  <div class="field col-12 md:col-6">
    <label [attr.for]="prefixo + 'Nome'" class="font-bold">Nome do comando</label>
    <input pInputText [attr.id]="prefixo + 'Nome'" [(ngModel)]="model.nome" class="w-full" />
  </div>
  <div class="field col-12 md:col-6">
    <label class="font-bold">Conexão</label>
    <p-dropdown [attr.id]="prefixo + 'Conexao'" [options]="conexoes" [(ngModel)]="model.conexaoId" optionLabel="nome" optionValue="id"
      placeholder="Selecione a conexão" styleClass="w-full" [filter]="true" appendTo="body" (onChange)="onConexaoChange()"></p-dropdown>
  </div>
  <div class="field col-12 md:col-6">
    <label class="font-bold">Endpoint</label>
    <p-dropdown [attr.id]="prefixo + 'Endpoint'" [options]="endpoints" [(ngModel)]="model.endpointId" optionLabel="nome" optionValue="id"
      placeholder="Selecione o endpoint" styleClass="w-full" [filter]="true" appendTo="body"></p-dropdown>
    <small class="text-500" *ngIf="endpoint">{{ endpoint.metodo }} <code>{{ endpoint.path }}</code></small>
    <small class="block aviso-chaves" *ngIf="variaveisFaltando.length > 0" [attr.id]="prefixo + 'AvisoPath'">
      <i class="pi pi-exclamation-triangle"></i> O path deste endpoint não usa <code>{{ textoVariaveisFaltando }}</code>:
      o valor do item não chegará à chamada.
    </small>
  </div>
  <div class="field col-12" *ngIf="mostrarCamposChave">
    <label class="font-bold">Campos chave (opcional)</label>
    <p-chips [(ngModel)]="model.camposChave" styleClass="w-full" [addOnBlur]="true" placeholder="Ex: ID"></p-chips>
    <small class="text-500">Identificam cada registro importado; vazio usa o hash do registro inteiro.</small>
  </div>
  <div class="field col-12">
    <label [attr.for]="prefixo + 'Corpo'" class="font-bold">Corpo da requisição (opcional)</label>
    <textarea pInputTextarea [attr.id]="prefixo + 'Corpo'" [(ngModel)]="model.comando" rows="3" class="w-full font-mono"
      placeholder="Vazio: os parâmetros abaixo viram query params"></textarea>
  </div>
  <div class="field col-12">
    <label class="font-bold">Parâmetros da requisição</label>
    <app-chave-valor [(valor)]="model.parametros" [prefixoId]="prefixo + 'Param'" rotuloChave="Nome" rotuloValor="Valor" rotuloAdicionar="Adicionar parâmetro"></app-chave-valor>
  </div>
</div>
